import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getCustomParams as getCustomParamsSelector } from 'MeetingsLib/selectors/BookInfoSelectors';
import { Flex } from 'foundations-components/components/Flex';
import { H5 } from 'foundations-components/transitional/components/H5';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { LocationIcon } from 'foundations-assets/icons/components/LocationIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Location = () => {
  const location = useSelector(getCustomParamsSelector).location;
  if (!location) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexGrow: "1",
    flexShrink: "0",
    flexBasis: "0",
    paddingBlockStart: "800",
    paddingInline: "800",
    inlineSize: "100%",
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(H5, {
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "prebook.location.header"
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(LocationIcon, {
        size: "400"
      }), /*#__PURE__*/_jsx(TruncateString, {
        marginInlineStart: "200",
        children: location
      })]
    })]
  });
};
export default Location;